<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="25rem" width="90%">
      <v-form
        ref="form"
        form="form"
        v-model="isFormValid"
        @submit.prevent="changePassword"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center pa-4">
            <span class="text-h6">Cambiar contraseña</span>
            <v-btn
              @click="closeModal"
              :icon="enums.icons.CLOSE_ICON"
              variant="text"
              size="small"
              id="v-btn-close-change-password"
              v-if="!changePasswordRequired"
              class="ml-auto"
              style="margin-right: -8px;"
            >
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4 pt-0">
            <v-container class="pa-0">
              <v-row>
                <!-- Contraseña actual -->
                <v-col cols="12" class="pt-1 pb-0">
                  <v-text-field
                    label="Contraseña actual"
                    id="current-password"
                    autocomplete="current-password"
                    :type="showLastPassword ? 'text' : 'password'"
                    v-model.trim="lastPassword"
                    :rules="rules.required.concat(rules.whiteSpaceNotAllowed)"
                    tabindex="1"
                    variant="outlined"
                    density="compact"
                  >
                    <v-icon
                      class="eye-icon"
                      @click="showLastPassword = !showLastPassword"
                      id="v-icon-eye-show-password"
                      tabindex="-1"
                    >
                      {{ showLastPassword ? "mdi-eye" : "mdi-eye-off" }}
                    </v-icon>
                  </v-text-field>
                </v-col>
                <!-- Contraseña nueva -->
                <v-col cols="12" class="pt-1 pb-0">
                  <v-text-field
                    label="Contraseña nueva"
                    id="new-password"
                    autocomplete="new-password"
                    :type="showNewPassword ? 'text' : 'password'"
                    v-model.trim="newPassword"
                    :rules="rules.password.concat(rules.whiteSpaceNotAllowed)"
                    tabindex="2"
                    ref="textFieldNueva"
                    variant="outlined"
                    density="compact"
                  >
                    <v-icon
                      class="eye-icon"
                      @click="showNewPassword = !showNewPassword"
                      id="v-icon-eye-show-password"
                      tabindex="-1"
                    >
                      {{ showNewPassword ? "mdi-eye" : "mdi-eye-off" }}
                    </v-icon>
                  </v-text-field>
                </v-col>
                <!-- Repetir contraseña -->
                <v-col cols="12" class="pt-1 pb-0">
                  <v-text-field
                    label="Repetir contraseña nueva"
                    ref="textFieldRepeat"
                    :type="showRepeatPassword ? 'text' : 'password'"
                    required
                    v-model.trim="repeatPassword"
                    id="new-password2"
                    tabindex="3"
                    autocomplete="new-password"
                    variant="outlined"
                    density="compact"
                    :rules="
                      newPassword != null
                        ? rules.required.concat([
                            rules.samePassword(newPassword, repeatPassword),
                          ])
                        : rules.required
                    "
                  >
                    <v-icon
                      class="eye-icon"
                      @click="showRepeatPassword = !showRepeatPassword"
                      id="v-icon-eye-show-password"
                      tabindex="-1"
                    >
                      {{ showRepeatPassword ? "mdi-eye" : "mdi-eye-off" }}
                    </v-icon>
                  </v-text-field>
                </v-col>
              </v-row>
              
              <!-- MENSAJE DE ERROR -->
              <v-row v-if="errorMessage">
                <v-col cols="12" class="pt-1 pb-0">
                  <v-alert
                    type="error"
                    variant="text"
                    density="compact"
                    class="mb-0"
                  >
                    {{ errorMessage }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>

            <!-- ACCIONES/BOTONES -->
            <v-card-actions class="justify-end py-0 px-0">
              <v-btn
                color="primary"
                variant="text"
                @click="logOut"
                tabindex="4"
                id="v-btn-logOut-change-password"
                v-if="changePasswordRequired"
              >
                Cerrar sesión
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                form="form"
                type="submit"
                tabindex="5"
                :disabled="!isFormValid"
                @click="confirm"
                id="v-btn-confirm-change-password"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import rules from "@/utils/helpers/rules";
import { mapActions } from "vuex";
import enums from "@/utils/enums/index";

export default {
  created() {
    this.userName = sessionStorage.getItem("userName");
    this.changePasswordRequired =
      sessionStorage.getItem("changePassword") === "true";
  },
  data() {
    return {
      dialog: true,
      showLastPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      lastPassword: "",
      newPassword: "",
      repeatPassword: "",
      rules: rules,
      buttonDisabled: true,
      isFormValid: false,
      userName: null,
      changePasswordRequired: false,
      enums: enums,
      errorMessage: null,
    };
  },
  watch: {
    newPassword() {
      setTimeout(async () => {
        await this.$refs.textFieldRepeat?.validate();
      }, 1);
      // Limpiar mensaje de error al cambiar contraseña
      this.errorMessage = null;
    },
    lastPassword() {
      // Limpiar mensaje de error al cambiar contraseña actual
      this.errorMessage = null;
    },
  },
  methods: {
    ...mapActions({
      postPassword: "password/savePassword",
      setAlert: "user/setAlert",
    }),
    async confirm() {
      // Limpiar mensaje de error previo
      this.errorMessage = null;
      
      const passwordData = {
        ActualPassword: this.lastPassword,
        NewPassword: this.newPassword,
      };
      try {
        const response = await this.postPassword(passwordData);
        if (response && response.status === 200) {
          this.setAlert({
            type: "success",
            message: "Contraseña guardada con éxito",
          });
          sessionStorage.setItem("changePassword", "false");
          this.closeModal();
        }
      } catch (error) {
        console.error("Error al guardar el cambio de contraseña", error);
        
        // Mostrar mensaje de error específico del backend si está disponible
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else {
          // No mostrar mensaje técnico - el interceptor global ya maneja errores HTTP
          this.errorMessage = null;
        }
      }
    },
    logOut() {
      sessionStorage.setItem("token", "");
      sessionStorage.removeItem("userName");
      this.$router.push("/login");
      this.$store.commit("menu/setPermisos", []);
    },
    closeModal() {
      this.$emit("close");
    },
    changePassword() {},
  },
};
</script>

<style scoped>
.eye-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

/* Mejoras de espaciado */
.v-text-field {
  margin-bottom: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .v-dialog {
    margin: 16px;
  }
  
  .v-card-title {
    font-size: 1.125rem !important;
    padding: 16px !important;
  }
  
  .v-card-text {
    padding: 16px !important;
    padding-top: 0 !important;
  }
}

@media (max-width: 400px) {
  .v-card-actions {
    flex-direction: column;
    gap: 8px;
    align-items: stretch !important;
    padding: 16px !important;
  }
  
  .v-card-actions .v-btn {
    width: 100%;
  }
}
</style>
